<template>

  <body>
    <!-- **************** MAIN CONTENT START **************** -->
    <main style="direction: rtl; text-align: right;">
      <!-- Main content START -->
      <div class="main-background pt-2 pb-0 position-relative">
        <!-- Container START -->
        <div class="container">
          <div class="row justify-content-center">
            <img class="light-mode-item navbar-brand-item" style="height: 180px;width: 210px;"
              src="../../assets/logo-dark.png" alt="logo">
            <div class="col-12 text-center">
              <!-- Title -->
              <span class="display-5 mainText">تسجيل الدخول</span>
            </div>
            <!-- Main content START -->
            <div class="col-sm-10 col-md-8 col-lg-6 position-relative z-index-1">
              <!-- Sign up form START -->
              <div class="card card-body p-4 p-sm-5 mt-sm-n5 mb-n5">
                <!-- Form START -->
                <form class="mt-4">
                  <!-- Email -->
                  <div class="mb-3 input-group-lg"> <!-- أيقونة المستخدم -->
                    <span class="d-block form-text-style">اسم المستخدم أو الإيميل *</span>
                    <input type="email" class="form-control" placeholder="أدخل الإيميل أو اسم المستخدم"
                      v-model="email" />
                    <span v-if="emailError" class="text-danger">{{ emailError }}</span>
                  </div>
                  <div class="mb-3 input-group-lg"> <!-- أيقونة القفل -->
                    <span class="d-block form-text-style">كلمة السر *</span>
                    <input type="password" class="form-control" placeholder="أدخل كلمة السر" v-model="password" />
                    <span v-if="passwordError" class="text-danger">{{ passwordError }}</span>
                  </div>
                  <p v-if="generalError" class="text-danger">{{ generalError }}</p>
                  <span class="d-block col-5 form-text-style-password">
                    هل نسيت كلمة السر؟
                  </span>
                  <!-- Button -->
                  <div class="d-grid">
                    <button @click.prevent="login" class="btn btn-lg signup-btn" :disabled="loading">
                      <span v-if="loading">
                        جارٍ التحميل...
                        <span class="spinner"></span>
                      </span>
                      <span v-else>تسجيل الدخول</span>
                    </button>
                  </div>

                </form>
                <!-- Copyright -->
                <p class="mb-0 mt-3 text-center">ليس لديك حساب؟ <span class="form-text-style-account">
                    <router-link to="/register" class="btn-signup">
                      سجل الآن
                    </router-link>
                  </span></p>
                <!-- Form END -->
                <div class="divider mb-0 mt-3 text-center">
                  <span>أو</span>
                </div>
                <div class="d-grid">
                  <GoogleLogin :clientId="YOUR_GOOGLE_CLIENT_ID" @success="onGoogleSignInSuccess"
                    @error="onGoogleSignInError">
                    تسجيل بواسطة جوجل
                  </GoogleLogin>
                </div>
              </div>
              <!-- Sign up form START -->
            </div>
          </div> <!-- Row END -->
        </div>
        <!-- Container END -->
      </div>
      <Footer />
    </main>
  </body>
</template>

<script>
import axios from "axios";
import Footer from '../../components/components/footer.vue';
import { GoogleLogin } from 'vue3-google-login';

export default {
  name: "LoginPage",
  components: {
    Footer,
    GoogleLogin,
  },
  data() {
    return {
      email: "",
      password: null,
      emailError: "",
      passwordError: "",
      generalError: "",
      loading: false,
      YOUR_GOOGLE_CLIENT_ID: "572471366403-vhse1b2619rjj16rrgl9k64ths8d1s1m.apps.googleusercontent.com",
    };
  },
  methods: {
    async login() {
      this.emailError = "";
      this.passwordError = "";
      this.generalError = "";
      this.loading = true; // تشغيل التحميل

      try {
        if (!this.email) {
          this.emailError = "يرجى إدخال البريد الإلكتروني.";
        }
        if (!this.password) {
          this.passwordError = "يرجى إدخال كلمة المرور.";
        }
        if (this.emailError || this.passwordError) {
          this.loading = false; // إيقاف التحميل
          return;
        }

        const formData = new FormData();
        formData.append("email", this.email);
        formData.append("password", this.password);

        const response = await axios.post(
          "https://zadcodeonline.com/ahmad/etqan/backEnd/auth/login.php",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.data.status === "success") {
          // تخزين بيانات المستخدم (رقم المستخدم)
          const userId = response.data.data.users_id; // رقم المستخدم من الاستجابة
          console.log("معلومات المستخدم:", response.data.data.users_id);

          localStorage.setItem("isAuthenticated", "true");
          localStorage.setItem("userId", userId); // تخزين رقم المستخدم

          // التوجيه إلى الصفحة الرئيسية
          this.$router.push("/home");
          // const userId = localStorage.getItem("userId");
          console.log("رقم المستخدم:", userId);

        } else {
          this.generalError = "خطأ في تسجيل الدخول.";
        }
      } catch (error) {
        this.generalError = "حدث خطأ أثناء محاولة تسجيل الدخول.";
      } finally {
        this.loading = false; // إيقاف التحميل بعد انتهاء العملية
      }
    },
    onGoogleSignInSuccess(response) {
      const idToken = response.credential; // الـ ID token من Google
      const email = response.profileObj.email; // البريد الإلكتروني من Google

      axios.post(
        "https://zadcodeonline.com/ahmad/etqan/backEnd/auth/signinwithgoogle.php",
        {
          idgoogle: idToken,
          email: email,
        }
      ).then((response) => {
        if (response.data.status === "success") {
          localStorage.setItem("isAuthenticated", "true");
          localStorage.setItem("userId", response.data.data.users_id);
          this.$router.push("/home");
        } else {
          this.generalError = "خطأ في تسجيل الدخول باستخدام Google.";
        }
      }).catch(() => {
        this.generalError = "حدث خطأ أثناء محاولة تسجيل الدخول باستخدام Google.";
      });
    },
    signInWithGoogle() {
      window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${this.YOUR_GOOGLE_CLIENT_ID}&redirect_uri=${window.location.origin}/auth/google/callback&response_type=code&scope=email profile`;
    },
    onGoogleSignInError(error) {
      console.error("Google Sign-In Error:", error);
      this.generalError = "حدث خطأ أثناء محاولة تسجيل الدخول باستخدام Google.";
    },
  },
};
</script>


<style scoped>
footer {
  bottom: 0;
  left: 0;
  width: 100%;
  color: #fff;
  background-color: #296080;
  padding: 20px;
  text-align: center;
  margin-top: 100px !important;
}

/* تحسين الخلفية */
.main-background {
  background: linear-gradient(to bottom, #f7f9fa, #d9e8ed);
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* تحسين النصوص */
.mainText {
  color: #296080;
  font-size: 2.2rem;
  font-weight: bold;
  margin-bottom: 20px;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
}

/* تأثيرات الأزرار */
.signup-btn:hover {
  background-color: #3a739b;
  transition: all 0.3s ease;
  transform: scale(1.02);
}

.signup-btn-google:hover {
  background-color: #f0f0f0;
  color: #000;
  transition: all 0.3s ease;
  transform: scale(1.02);
}

/* الحقول */
.form-control {
  border-radius: 12px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.form-control:focus {
  border-color: #296080;
  box-shadow: 0px 0px 10px rgba(41, 96, 128, 0.5);
}

/* أيقونات */
.input-group-lg {
  position: relative;
}

.input-group-lg input {
  padding-left: 40px;
}

.input-group-lg::before {
  content: attr(data-icon);
  font-family: FontAwesome;
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  font-size: 1.2rem;
  color: #296080;
}

/* تحسين النصوص */
.form-text-style {
  font-weight: 700;
  margin-bottom: 5px !important;
}

.form-text-style-password:hover {
  color: #FF6F61;
  text-decoration: underline;
  cursor: pointer;
}

/* شريط التحميل */
.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #296080;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  animation: spin 1s linear infinite;
  display: inline-block;
  margin-right: 8px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}




h3 {
  margin: 40px 0 0;
}

.divider {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
  position: relative;
}

.divider::before,
.divider::after {
  content: "";
  flex: 1;
  height: 1px;
  background-color: #ccc;
  margin: 0 10px;
}

.divider span {
  margin-bottom: 30px;
  display: inline-block;
  font-weight: 700;
  padding: 0 10px;
  background: #fff;
  font-size: 1rem;
  color: #333;
}

.mainText {
  color: #296080;
  right: 15px;
  text-align: right;
}

.mb-n5 {
  margin-top: 15px !important;
}

.form-text-style {
  font-weight: 700;
  margin-bottom: 5px !important;
}

.form-text-style-password {
  color: #EF845D;
  margin-bottom: 15px !important;
  border-bottom: 1px solid #EF845D;
}

.btn-signup {
  color: #296080;
}


.form-text-style-account {
  color: #EF845D;
}

.main-background {
  background-color: #D9E8ED;
}

.form-control {
  border-radius: 12px;
}

.signup-btn {
  background-color: #296080;
  color: #fff;
  border-radius: 12px;
}

.signup-btn-google {
  color: #000000;
  border-radius: 12px;
  border: 1px solid #929292;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
